import { POST } from "./AxiosRequest";


export function SEND_NOTIFICATION_SLACK(sender, user, message, link){
	if(process.env.NODE_ENV === "production") 
		return POST("slack/sendNotificationToUser", {sender: sender, user: user, message: message, link: link})
	else
		return null;
}